import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    screenBg: "#fff"
};

export const ScreenBgSlice = createSlice({
    name: "subscription",
    initialState,
    reducers: {
        setScreenBg: (state, action) => {
            state.screenBg = action.payload;

        },

    },
});

export const { setScreenBg } = ScreenBgSlice.actions;
export default ScreenBgSlice.reducer;
